import { OrganismeFichierDto } from '@common/services';
import { SavedFile } from '@common/ui';

export function toSavedFile(organismeFichier: OrganismeFichierDto): SavedFile {
  const { fichier, subType } = organismeFichier;
  return {
    id: fichier.id,
    name: fichier.nom,
    type: subType,
    url: null,
    size: fichier.taille,
  };
}